// addPendingRemoveSearchParams.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Add pending remove search param
 * @kind action
 * @param {string[]} {queryKeys} - array of query keys
 * @return {Promise} Action promise.
 */
const addPendingRemoveSearchParams =
  ({ queryKeys }) =>
  async (dispatch, getState) => {
    if (!queryKeys || queryKeys?.length === 0) return dispatch({ type: '' });

    const currentQueryKeys =
      getOperationData(getState(), ['pendingRemoveSearchParam'], 'query') || [];
    const query = [...new Set([...currentQueryKeys, ...queryKeys])];

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['pendingRemoveSearchParam'],
        data: { query },
      },
    });
  };

export default addPendingRemoveSearchParams;
